export default "__VITE_ASSET__DMz5nOYP__"